'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_OPTIONS = exports.USE_CLASSES = exports.ICON_SIZE_MAP = exports.ICON_COLOR_MAP = undefined;

var _colors = require('HubStyleTokens/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ICON_COLOR_MAP = exports.ICON_COLOR_MAP = {
  danger: colors.ALERT_DANGER,
  primary: colors.LORAX,
  secondary: colors.LORAX,
  'secondary-ghost': colors.OLAF,
  tertiary: colors.HEFFALUMP,
  success: colors.OZ,
  link: colors.CALYPSO,
  'on-dark': colors.OLAF
};

var ICON_SIZE_MAP = exports.ICON_SIZE_MAP = {
  'extra-small': 10,
  small: 16,
  medium: 24
};

var USE_CLASSES = exports.USE_CLASSES = {
  danger: 'private-spinner--destructive',
  primary: 'private-spinner--primary',
  'primary-white': 'private-spinner--primary-white',
  secondary: 'private-spinner--secondary',
  'secondary-ghost': 'private-spinner--secondary-ghost',
  tertiary: 'private-spinner--tertiary',
  success: 'private-spinner--success',
  'tertiary-light': 'private-spinner--tertiary', // same as tertiary
  link: 'private-spinner--link',
  'on-dark': 'private-spinner--on-dark'
};

var SIZE_OPTIONS = exports.SIZE_OPTIONS = {
  'extra-small': '20px',
  small: '28px',
  medium: '40px'
};